<script setup>
import { ref, computed, onMounted } from 'vue';
import { assocPath } from 'ramda';
import { isIndividualPlan } from '@/utilities';
import {hasCompanyPlan, useGlobalState} from '@/store/user.store';
import AccountDetailsCompanyComponent from '@/components/register/AccountDetailsCompanyComponent.vue';
import AccountDetailsIndividualComponent from '@/components/register/AccountDetailsIndividualComponent.vue';
import AccountCompanyDetailsForm from '@/components/forms/AccountCompanyDetailsForm.vue';
import { trackEvent } from '@/services/analytics/googleAnalytics.js';

const props = defineProps(['chosenPlan']);
const emit = defineEmits(['detailsConfirmed', 'back']);

const { userState, isAuthenticated } = useGlobalState();

const isCompanyPlan = computed(() => !isIndividualPlan(props.chosenPlan));
const shouldRenderForm = ref(true);

onMounted(() => {
  trackEvent('create_account_step', {
    event_category: 'Register',
    event_label: 'Create Account Step',
  });

  if (isAuthenticated()) {
    if (isCompanyPlan.value) {
      // Show AccountCompanyDetailsForm
    } else {
      const payload = assocPath(['user', 'email'], userState.value.email)({});
      emit('detailsConfirmed', payload);
      shouldRenderForm.value = false;
    }
  }
});
</script>

<template>
  <AccountCompanyDetailsForm
    v-if="isAuthenticated() && isCompanyPlan && shouldRenderForm"
    @details-confirmed="emit('detailsConfirmed', $event)"
    @back="emit('back')"
  />

  <AccountDetailsCompanyComponent
    v-else-if="!isAuthenticated() && isCompanyPlan"
    @details-confirmed="emit('detailsConfirmed', $event)"
    @back="emit('back')"
  />

  <AccountDetailsIndividualComponent
    v-else-if="!isAuthenticated() && !isCompanyPlan"
    @details-confirmed="emit('detailsConfirmed', $event)"
    @back="emit('back')"
  />
</template>
